import React from 'react';

/**
 * Logo officiel CodeVoiture.fr
 * - "horizontal" : PNG officiel desktop (silhouette + wordmark)
 * - "mark"       : version icone mobile
 *
 * Les fichiers se trouvent dans /public/logo-desktop.png et /public/logo-mobile.png
 */
export default function Logo({ variant = 'horizontal', className = '', height = 48, alt = 'CodeVoiture.fr' }) {
  const src = variant === 'mark' ? '/logo-mobile.png' : '/logo-desktop.png';
  return (
    <span className="inline-block select-none">
      <img
        src={src}
        alt={alt}
        style={{ height: `${height}px`, width: 'auto' }}
        className={`block select-none logo-dark ${className}`}
        draggable={false}
      />
      <img
        src="/logo-light.png"
        alt={alt}
        style={{ height: `${height}px`, width: 'auto' }}
        className={`select-none logo-light ${className}`}
        draggable={false}
      />
    </span>
  );
}
